import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";

export const PublishersUrl = "rmn-publishers";

export interface PublisherServerResponse {
  id: number;
  name: string;
}

export interface Publisher {
  id: number;
  name: string;
}

const usePublishers = () => {
  const { data, error, isLoading } = useSWR(
    `${RelativeUrl}/${PublishersUrl}`,
    (url: string) => fetcher<PublisherServerResponse[]>(url),
    {
      revalidateIfStale: false
    }
  );

  return {
    publishers: data as Publisher[] | undefined,
    error,
    isLoading
  };
};

export default usePublishers;
